import * as domUtils from '../../util/dom';

const CAPTIONS_STORAGE_KEY = 'captionsOn';

export default class DashSubtitles {
    constructor(videoElement, mediaPlayer, api, dashjs) {
        this.videoElement = videoElement;
        this.mediaPlayer = mediaPlayer;
        this.api = api;

        this.enabled = false;

        this.domElement = document.createElement('div');
        this.domElement.className = 'svp_dash-captions';
        this.api.element().appendChild(this.domElement);

        this.mediaPlayer.attachTTMLRenderingDiv(this.domElement);
        this.visible = domUtils.getStoredData(CAPTIONS_STORAGE_KEY) === 'true';

        this._onTextTrackAdded = () => {
            this.enabled = true;
            this.api.fire('captionsloaded');

            if (this.visible) {
                this.show();
            } else {
                this.hide();
            }
        };

        mediaPlayer.on(dashjs.MediaPlayer.events.TEXT_TRACK_ADDED, this._onTextTrackAdded);

        this.api.on('subtitles.controls', this._onControls.bind(this));
    }

    isEnabled() {
        return this.enabled;
    }

    show() {
        this.visible = true;

        if (this.videoElement.getTextTracks().length > 0) {
            this.mediaPlayer.setTextTrack(0);
        }
    }

    hide() {
        this.visible = false;

        if (this.videoElement.getTextTracks().length > 0) {
            this.mediaPlayer.setTextTrack(-1);
        }
    }

    _onControls(controlsEvent) {
        if (controlsEvent.detail.visible) {
            this.domElement.classList.add('elevated');
        } else {
            this.domElement.classList.remove('elevated');
        }
    }

    detach() {
        this.api.off('subtitles.controls');
        this.api.element().removeChild(this.domElement);
        this.enabled = false;
        this.mediaPlayer.off(dashjs.MediaPlayer.events.TEXT_TRACK_ADDED, this._onTextTrackAdded);
    }
}



// WEBPACK FOOTER //
// ./src/js/modules/dash/dash-subtitles.js